<button
  pButton
  pRipple
  type="button"
  [label]="languageKey.CANCEL | translateKey"
  icon="pi pi-times"
  class="p-button-raised p-button-secondary"
></button>
